import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Fingerprint, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiError } from "@/lib/api";

export default function StaffLogin() {
  const navigate = useNavigate();
  const [nid, setNid] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!nid.trim() || !code.trim()) { setError("أدخل رقم الهوية ورمز المدرسة"); return; }
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/staff/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ national_id: nid.trim(), school_code: code.trim() }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(formatApiError(data.detail));
      localStorage.setItem("staff_token", data.token);
      localStorage.setItem("staff_employee", JSON.stringify(data.employee));
      localStorage.setItem("staff_last_active", String(Date.now()));
      navigate("/staff/home");
    } catch (err) {
      setError(err.message || "تعذر تسجيل الدخول");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="staff-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-2xl bg-emerald-950 flex items-center justify-center mx-auto mb-3">
            <Fingerprint className="w-7 h-7 text-amber-400" />
          </div>
          <h1 className="text-xl font-extrabold text-emerald-950">بوابة الموظفين</h1>
          <p className="text-xs text-slate-400 mt-1">راصد حضوري — دخول بدون بريد إلكتروني</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl border shadow-sm p-6 space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs">رقم الهوية الوطنية</Label>
            <Input value={nid} onChange={(e) => setNid(e.target.value)} dir="ltr"
              inputMode="numeric" placeholder="10xxxxxxxx" className="h-11 text-center font-mono"
              data-testid="staff-login-national-id" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs">رمز المدرسة</Label>
            <Input value={code} onChange={(e) => setCode(e.target.value)} dir="ltr"
              inputMode="numeric" placeholder="رمز مكوّن من 6 أرقام" className="h-11 text-center font-mono"
              data-testid="staff-login-school-code" />
            <p className="text-[10px] text-slate-400">تحصل عليه من إدارة مدرستك</p>
          </div>
          {error && (
            <p className="text-xs font-semibold text-rose-600 bg-rose-50 border border-rose-200 rounded-xl px-3 py-2"
              data-testid="staff-login-error">{error}</p>
          )}
          <Button type="submit" disabled={loading}
            data-testid="staff-login-submit"
            className="w-full h-11 bg-emerald-900 hover:bg-emerald-950 text-white font-bold">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "دخول"}
          </Button>
        </form>
        <p className="text-center text-[10px] text-slate-400 mt-4">
          تنتهي الجلسة تلقائياً بعد 30 دقيقة من عدم النشاط حفاظاً على خصوصيتك
        </p>
      </div>
    </div>
  );
}
